// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileMarkdownTwoToneSvg from "@ant-design/icons-svg/es/asn/FileMarkdownTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileMarkdownTwoTone = function FileMarkdownTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownTwoToneSvg
  }));
};

FileMarkdownTwoTone.displayName = 'FileMarkdownTwoTone';
export default React.forwardRef(FileMarkdownTwoTone);